var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ShareNetwork',{attrs:{"network":"twitter","url":_vm.url,"title":_vm.title,"quote":_vm.quote,"hashtags":_vm.hashtags}},[_c('i',{staticClass:"lg el-icon-share"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }